import React from "react";
import SectionHeader from "./components/SectionHeader";
import SectionFooter from "../../components/SectionFooter";
import Ellipses from "../../components/Ellipses";
import { Outlet } from "react-router-dom";
import useCurrentLocation from "../../hooks/useCurrentLocation";
import MediumScreenLines from "../../components/MediumScreenLines";
import "./style.scss";

function AdsLandingPage() {
  const { currentLocationIs } = useCurrentLocation();
  const isConditionsOpen = currentLocationIs("/conditions");
  const isPrivacyOpen = currentLocationIs("/privacy");
  const isHideBackgroundElems = [isConditionsOpen, isPrivacyOpen].some(
    (isOpen) => !!isOpen
  );
  return (
    <div className="ads-landing-wrapper">
      {!isHideBackgroundElems && (
        <>
          <Ellipses className="ads-landing-ellipse" countEllipses={3} />
        </>
      )}
      <div className="ads-landing-wrapper__sections">
        <SectionHeader isHideBackgroundElems={isHideBackgroundElems} />
        <Outlet />
        <SectionFooter />
      </div>
    </div>
  );
}

export default AdsLandingPage;
